import { faBuilding, faMagnifyingGlass, faUser } from "@fortawesome/pro-regular-svg-icons";

const RECENT_SEARCHES_KEY = "globalSearch.byName.recentSearches";
// Keep more than we show so removing a visible entry reveals an older saved one.
const MAX_STORED_SEARCHES = 5;
export const MAX_VISIBLE_SEARCHES = 5;

export type RecentSearchKind = "query" | "person" | "company";

export interface RecentSearch {
	kind: RecentSearchKind;
	name: string;
}

export const RECENT_SEARCH_ICONS: Record<RecentSearchKind, typeof faMagnifyingGlass> = {
	query: faMagnifyingGlass,
	person: faUser,
	company: faBuilding,
};

export const loadRecentSearches = (): RecentSearch[] => {
	try {
		const raw = localStorage.getItem(RECENT_SEARCHES_KEY);

		if (!raw) {
			return [];
		}

		const parsed = JSON.parse(raw);

		if (!Array.isArray(parsed)) {
			return [];
		}

		return parsed.filter(
			(item): item is RecentSearch =>
				!!item &&
				typeof item.name === "string" &&
				(item.kind === "query" || item.kind === "person" || item.kind === "company")
		);
	} catch {
		return [];
	}
};

export const persistRecentSearches = (searches: RecentSearch[]): void => {
	try {
		localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(searches));
	} catch {
		// ignore write errors (quota exceeded / storage unavailable)
	}
};

export const clearStoredRecentSearches = (): void => {
	try {
		localStorage.removeItem(RECENT_SEARCHES_KEY);
	} catch {
		// ignore — storage may be unavailable
	}
};

export const pushRecentSearch = (prev: RecentSearch[], entry: RecentSearch): RecentSearch[] =>
	// Dedupe by name across all kinds so the same name never appears twice.
	[entry, ...prev.filter((s) => s.name !== entry.name)].slice(0, MAX_STORED_SEARCHES);
